import MarkdownIt, { PluginSimple } from 'markdown-it';
import { MarkdownParser, ParseSpec } from 'prosemirror-markdown';
import { Schema } from 'prosemirror-model';

export function getMarkdownParser(
  schema: Schema,
  tokens: Record<string, ParseSpec>,
  plugins?: PluginSimple[],
) {
  const markdownIt = MarkdownIt('default', {
    breaks: false,
    html: false,
    linkify: false,
  });

  plugins?.forEach((plugin) => {
    markdownIt.use(plugin);
  });

  const parser = new MarkdownParser(schema, markdownIt, tokens);
  return parser;
}

export const getPMDocFromMarkdown = (props: {
  value: string;
  schema: Schema;
  markdownTokens: Record<string, ParseSpec>;
}) => {
  const { value, schema, markdownTokens } = props;
  const markdownParser = getMarkdownParser(schema, markdownTokens);
  return markdownParser.parse(value);
};
